export default __webpack_public_path__ + "static/media/cpt.44c1eac8.png";